import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { Animated, ImageBackground, ScrollView, StyleSheet, Text, View } from "react-native";


import GlobalStyles from "../../../globalStyles/globalStyles";
import FeedIcons from "../../../assets/Icons/FeedIcons";
import ExperienceCoachMarkScreen from "./CoachMarkScreen/ExperienceCoachMarkScreen";
import ExperienceIcons from "../../../assets/Icons/ExperienceIcons";


const InitialEmptyScreen = () => {
 const navigation = useNavigation();

  const [showCoachMark, setShowCoachMark] = useState(false);
  const [coachMarkVisited, setCoachMarkVisited] = useState(false);
  const [opacity] = useState(new Animated.Value(0));

  useEffect(() => {
    const checkCoachMarkVisited = async () => {
      try {
        const visited = await AsyncStorage.getItem('experienceCoachMarkVisited');
        if (visited !== null) {
          setCoachMarkVisited(true);
        }
      } catch (error) {
        console.error('Error retrieving coach mark visit status:', error);
      }
    };

    checkCoachMarkVisited();
  }, []);

  //responsible for the transition between the 2 screens
  useEffect(() => {
      let timer:any;
      if (!coachMarkVisited) {
        timer = setTimeout(() => {
        Animated.timing(opacity, {
          toValue: 1,
          duration: 1000,
          useNativeDriver: true,
        }).start();
          setShowCoachMark(true);
        }, 1000);
      }
      return () => clearTimeout(timer);
  }, [coachMarkVisited]);

  const handleGotIt = async () => {
    try {
      await AsyncStorage.setItem('experienceCoachMarkVisited', 'true');
      setCoachMarkVisited(true);
      Animated.timing(opacity, {
        toValue: 0,
        duration: 1000,
        useNativeDriver: true,
      }).start(() => setShowCoachMark(false));
    } catch (error) {
      console.error('Error setting coach mark visit status:', error);
    }
  };


  return (
    <View style={{
      position:"relative",
      flex:1,
    }}>
      {
      showCoachMark &&
        <Animated.View style={{ 
          flex: 1, 
          opacity:opacity,
          position:"absolute",
          width:"100%",
          height:"100%",
          zIndex:showCoachMark? 2:0
          }}>
          <ExperienceCoachMarkScreen onGotIt={handleGotIt} />
        </Animated.View>
     }
     <View style={{
      position:"absolute",
      flex:1,
      width:"100%",
      height:"100%",
     }}>
     <ImageBackground
      source={require("../../../assets/StaticImages/ExperienceImages/experience_date1.png")}
        style={{
          flex: 1,
          backgroundColor: "#000",
          // marginTop: 15,
        }}
      >
        <ScrollView>
          <View style={styles.Container}>
            <Text
              style={[
                GlobalStyles.heading2,
                {
                  paddingHorizontal: 16,
                  color:"white"
                },
              ]}
            >
              Experiences
            </Text>
           
           <View
                  style={{
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "57%",
                  }}
                >
                  <View
                    style={{
                      transform: [{ scale: 1.9 }],
                    }}
                  >
                    <ExperienceIcons.MainExperienceScreenIcon />
                  </View>
                  <Text
                    style={[
                      GlobalStyles.heading2,
                      { marginTop: 40, textAlign: "center",color:"white" },
                    ]}
                  > 
                    Your experiences will{"\n"}
                    appear here
                  </Text>
                </View>
            
          </View>
        </ScrollView>
      </ImageBackground>
     </View> 
    </View>
  )
};

export default InitialEmptyScreen;

const styles = StyleSheet.create({
  Container:{
   marginTop: 20,
  }
})